import { RootState } from './../../store/index';
import { createSelector } from "@reduxjs/toolkit";

export const selectSnacks = createSelector(
  (state: RootState) => state.system.snacks,
  (snacks) => snacks
);
